import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 100;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);
  const scrollToCta = () => {
    const element = document.getElementById('final-cta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <AnimatePresence data-id="element-124">
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.5
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-primary/90 backdrop-blur-md border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-125">
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center" data-id="element-126">
          <div className="text-gold font-bold text-xl tracking-wider" data-id="element-127">
            THE F-FORMULA
          </div>

          <motion.button onClick={scrollToCta} initial={{
          opacity: 0
        }} animate={{
          opacity: scrolled ? 1 : 0
        }} className="bg-gold hover:bg-gold-light text-primary font-bold py-2 px-6 rounded-sm text-sm transition-colors duration-300" data-id="element-128">
            Acceder ahora
          </motion.button>
        </div>
      </motion.nav>
    </AnimatePresence>;
}